// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

const COPYRIGHT = ` 2019 - ${new Date().getFullYear()} Nykaa Fashion Pvt. Ltd. All Rights Reserved`;

const Container = styled.div`
  height: 45px;
  background: ${({ theme }) => theme.colors.salmon500};
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  padding-top: ${({ theme }) => theme.spacing.spacing80};
  ${({ theme }) => theme.typography.bodySmall};
`;

function Terms() {
  return <Container>&copy;{COPYRIGHT}</Container>;
}

export default memo(Terms);
